import { render, staticRenderFns } from "./TitleMatchConfirmationDialog.vue?vue&type=template&id=139ff39a"
import script from "./TitleMatchConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./TitleMatchConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports